import React, { useEffect, useState, useRef } from "react";
import "../style/home.scss";
import HeaderBar from "./common/HeaderBar";
import { getCategoryList } from "../apis/GetProduct";
import PagePath from "../util/RoutePagePath";
import { routeToPage } from "../util/RouteToPage";
import { useNavigate } from "react-router-dom";
import FooterBar from "./common/FooterBar";
import row1 from "../image/row1.webp";
import row1_1 from "../image/row1-1.webp";
import row1_2 from "../image/row1-2.webp";
import row2 from "../image/row2.webp";
import row2_1 from "../image/row2-1.webp";
import row2_2 from "../image/row2-2.webp";
import row2_3 from "../image/row2-3.webp";
import row2_4 from "../image/row2-4.webp";
import row3 from "../image/row3.webp";
import row3_1 from "../image/row3-1.webp";
import row3_2 from "../image/row3-2.webp";
import row3_3 from "../image/row3-3.jpg";
import row4 from "../image/row4.webp";
import row4_1 from "../image/row4-1.webp";
import row4_2 from "../image/row4-2.webp";
import row4_3 from "../image/row4-3.webp";
import row4_4 from "../image/row4-4.webp";
import row4_5 from "../image/row4-5.webp";
import row5 from "../image/row5.webp";
import row5_1 from "../image/row5-1.jpg";
import row5_2 from "../image/row5-2.webp";
import row6 from "../image/row6.jfif";
import row6_1 from "../image/row6-1.jfif";
import row6_2 from "../image/row6-2.webp";
import row7 from "../image/row7.webp";

import { currency } from "./common/Common";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { EffectFade, Autoplay, Pagination } from "swiper/modules";

const Home = () => {
  const [productList, setProductList] = useState([]);
  const navigate = useNavigate();

  const [position, setPosition] = useState(50);
  const [dragging, setDragging] = useState(false);
  const ref = useRef(null);

  const onMove = (e) => {
    if (!dragging) return;

    const rect = ref.current.getBoundingClientRect();
    let x = e.clientX - rect.left;
    let percent = (x / rect.width) * 100;

    if (percent < 0) percent = 0;
    if (percent > 100) percent = 100;

    setPosition(percent);
  };

  useEffect(() => {
    let list1 = getCategoryList("Best Sellers");
    let list2 = getCategoryList("Passport & Travel");
    let list3 = getCategoryList("Crossbody Bags");
    setProductList([list1]);
  }, []);

  // 鼠标悬停切换图片
  const handleHover = (listIndex, itemIndex, ishover) => {
    setProductList((prev) =>
      prev.map((list, lIdx) =>
        lIdx === listIndex
          ? {
              ...list,
              list: list.list.map((item, iIdx) =>
                iIdx === itemIndex ? { ...item, ishover } : item,
              ),
            }
          : list,
      ),
    );
  };
  return (
    <React.Fragment>
      <HeaderBar />
      <div className="">
        <div className="relative h-screen">
          <img src={row1} alt="" className="h-full w-full object-cover" />
          <div className="absolute inset-0 z-20 flex h-full w-full flex-col justify-center p-20 text-center text-white">
            <p className="text-[80px] font-bold tracking-[4px]">
              Provisions For The Untamed
            </p>
            <p className="tracking-[4px]">
              Full-Grain Bags. Leather-Patch Hats. Small-Batch Coffee.
            </p>
          </div>
        </div>
        <div className="relative my-10 h-screen">
          <img src={row1_1} alt="" className="h-full w-full object-cover" />
          <div className="absolute inset-0 z-20 flex h-full w-full flex-col justify-center p-20 text-center text-white">
            <p className="text-[80px] font-bold tracking-[4px]">
              Elviroxab Leather Bags
            </p>
            <p className="tracking-[4px]">
              From Haul to Hand-Sized. The right mix for <br /> workdays,
              weekends, and whatever’s next.
            </p>
          </div>
        </div>

        {/* product */}
        <div className="mx-auto my-section px-20">
          {productList?.map((item, listIndex) => (
            <React.Fragment>
              <div key={listIndex}>
                <div className="font-500 mx-auto mb-2 text-center text-[24px] uppercase tracking-[5px]">
                  {item?.category}
                </div>
                <div className="mx-auto grid cursor-pointer grid-cols-1 gap-10 gap-y-20 p-10 text-center sm:grid-cols-2 lg:grid-cols-4">
                  {item?.list?.map((i, itemIndex) => (
                    <div
                      key={itemIndex}
                      onMouseEnter={() =>
                        handleHover(listIndex, itemIndex, true)
                      }
                      onMouseLeave={() =>
                        handleHover(listIndex, itemIndex, false)
                      }
                      onClick={() =>
                        routeToPage(
                          navigate,
                          `${PagePath.PRODUCTDETAIL_PAGE}/${i.id}`,
                        )
                      }
                    >
                      <div className="bg-grey aspect-1 mb-2 overflow-hidden">
                        <img
                          src={
                            i.ishover ? (i.image[1] ?? i.image[0]) : i.image[0]
                          }
                          alt=""
                          className="object-cover"
                        />
                      </div>
                      <div className="my-4 text-[16px]">{i.title}</div>
                      <div className="text-[14px] font-bold text-price">
                        {currency}
                        {i.price?.toLocaleString()}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
        <div className="relative my-10 h-screen">
          <img src={row2} alt="" className="h-full w-full object-cover" />
          <div className="absolute inset-0 z-20 flex h-full w-full flex-col justify-center p-20 text-center text-white">
            <p className="text-[80px] font-bold tracking-[4px]">
              Elviroxab Coffee
            </p>
            <p className="leading-6 tracking-[4px]">
              We approach coffee the same way as leather — <br /> with patience,
              precision, and craft.
            </p>
          </div>
        </div>
        <div className="relative my-10 h-screen">
          <img src={row2_1} alt="" className="h-full w-full object-cover" />
          <div className="absolute inset-0 z-20 flex h-full w-full flex-col justify-center p-20 text-center text-white">
            <p className="text-[80px] font-bold tracking-[4px]">Custom Shop</p>
            <p className="leading-6 tracking-[4px]">
              Hundreds of brands trust us to provide the highest quality custom{" "}
              <br /> products for their businesses and organizations, we can’t
              wait to work <br /> with you.
            </p>
          </div>
        </div>
        {/* category */}
        <div className="mx-auto px-20 py-5">
          <div className="mt-10 grid grid-cols-3 gap-20">
            <div>
              <img src={row3} alt="" />
            </div>

            <div>
              <img src={row3_1} alt="" />
            </div>
            <div>
              <img src={row3_2} alt="" />
            </div>
          </div>
        </div>
      </div>
      <FooterBar />
    </React.Fragment>
  );
};

export default Home;
